export default __webpack_public_path__ + "static/SIM-physical-mandate-46540148bc83d93b9b11e3db267792b9.pdf";